/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: ESM Woocommerce to Hubspot Integration
  Author: Wibert Muza
  Agency URL: https://esminbound.com
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    header: 'Connected Apps',
    icon: 'PackageIcon',
    i18n: 'Connected Apps',
    items: [
      {
        url: '/connections/hubspot',
        name: 'Hubspot',
        slug: 'hubspot',
        icon: 'PieChartIcon',
        i18n: 'Hubspot'
      },
      {
        url: '/connections/woocommerce',
        name: 'Woocommerce',
        slug: 'woocommerce',
        icon: 'ShoppingCartIcon',
        i18n: 'Woocommerce'
      }
    ]
  },
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'settings',
    items: [
      {
        url: '/sync/configuration',
        name: 'Configuration',
        slug: 'configuration',
        icon: 'SettingsIcon',
        i18n: 'Configuration'
      }
    ]
  },
  {
    header: 'Customers',
    icon: 'CopyIcon',
    i18n: 'customers',
    items: [
      {
        url: '/list/customers',
        name: 'Customer List',
        slug: 'products',
        icon: 'ActivityIcon',
        i18n: 'Customer List'
      },  
      {
        url: '/errors/customers',
        name: 'Customer Sync Errors',
        slug: 'customers-errors',
        icon: 'AlertOctagonIcon',
        i18n: 'Customer Sync Errors'
      },     
    ]
  },
  {
    header: 'Products',
    icon: 'CopyIcon',
    i18n: 'products',
    items: [
      {
        url: '/list/products',
        name: 'Product List',
        slug: 'products',
        icon: 'ActivityIcon',
        i18n: 'Product List'
      },  
      {
        url: '/errors/products',
        name: 'Products Sync Errors',
        slug: 'products-errors',
        icon: 'AlertOctagonIcon',
        i18n: 'Products Sync Errors'
      },    
    ]
  },
  {
    header: 'Orders',
    icon: 'CopyIcon',
    i18n: 'orders',
    items: [
      {
        url: '/list/orders',
        name: 'Order List',
        slug: 'products',
        icon: 'ActivityIcon',
        i18n: 'Order List'
      },  
      {
        url: '/errors/orders',
        name: 'Orders Sync Errors',
        slug: 'orders-errors',
        icon: 'AlertOctagonIcon',
        i18n: 'Orders Sync Errors'
      },    
    ]
  },
]
